import { TextField } from "@material-ui/core";

const AgentCommentsTextField = (props) => {
  const { textPlaceholderText, textValue, textOnChange } = props;
  return (
    <TextField
      multiline
      variant="outlined"
      rows={3}
      placeholder={textPlaceholderText}
      value={textValue}
      onChange={textOnChange}
      style={{ marginBottom: "3%" }}
      fullWidth={true}
    />
  );
};

export default AgentCommentsTextField;
